import axios from "axios";

export let backendUrl = 'http://170.64.146.173:8000/';